import { useEffect, useState } from "react";

import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicTable, MASK_MONEY } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _SubMacroProcess } from "../../../core/services/dataBean/EntityCatalog";
import { _RawMaterialManufacturing } from "../../../core/services/dataBean/EntityCatalogVdos";
import { SelectProductVariantByManufacturing } from "../../Inventories-Warehouses/Product/SelectProductVariantByManufacturing";
import { InputMoney } from "../../theme/Input/InputMoney";



interface Props {
    idManufacturingStardard: number;
}

export const RawMaterialByManufacturingVariant = ({ idManufacturingStardard }: Props) => {

    const Raw = useDataBean(_RawMaterialManufacturing);
    const [variant, setVariant] = useState<number>(null)
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [variant])

    const getLista = () => {

        Raw.instance.getRawMaterialCatalog(idManufacturingStardard, variant).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        Raw.setBean({
            IDManufacturingStardard: idManufacturingStardard
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        Raw.deleteItemVoid(Raw.bean.IDRawMaterial).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        Raw.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }


    const setQuantityToRawMaterial = () => {
        Raw.instance.setQuantityToRawMaterial(Raw.bean.IDRawMaterial, variant, Raw.bean.VariantQuantity).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    getLista();
                    setModal({ ...modal, "view": false });
                }
            }
        )

    }

    const head = [
        { title: 'ID', property: 'IDRawMaterial', visible: true },
        { title: 'Nombre del Inventario', property: 'Name', visible: true },
        { title: 'Producto Final', property: 'ProductName', visible: true },
        { title: 'Código de Referencia-SKU', property: 'StockKeepingUnit', visible: true },
        { title: 'Cantidad', property: 'VariantQuantity', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Costo Unitario', property: 'UnitaryCost', visible: true, mask: MASK_MONEY },
        { title: 'Empleado', property: 'EmployeeName', visible: true },
    ]

    // const iconButtonsItem = [
    //     { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    // ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            // { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-6">
                <SelectProductVariantByManufacturing idManufacturingStardard={idManufacturingStardard} idSelector={variant} onChange={setVariant} />
                <p><strong>Debe Seleccionar Una Talla para el producto*</strong></p>
            </div>
            {variant &&

                <>
                    <div className="col-md-12">
                        <BasicTable body={lista} head={head} rowSet={Raw.setBean} listButtons={listaBotones()} ></BasicTable>
                    </div>
                </>
            }

            <div className="col-md-12">

                <Modal modal={modal} updateModal={setModal} eventModal={setQuantityToRawMaterial}>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Cantidad</label>
                            <input type="number" name="VariantQuantity" className="form-control" value={Raw.bean.VariantQuantity} onChange={Raw.handleChange} />
                            {/* <InputMoney _label='Cantidad' _value={Raw.bean.Quantity} onChange={(e: any) => { Raw.setBean({ ...Raw.bean, 'Quantity': e }) }} /> */}
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}